<div class="card__header">
  <h2>Recertificação periódica</h2>
  @if (!mode) {
    <span class="close-btn material-icons" (click)="closeSideNav()">close</span>
  }
</div>

@if (!this.hasError) {
  @if (!success) {
    <section class="card__section">
      <pl-alert color="warning" [hidden]="!mode">
        <span header>Atenção</span>
        <span content>
          @if (userMeInfo$ | async; as userMeInfo) {
            Sua certificação expirou dia
            <strong
              >{{ userMeInfo?.recertification?.limitDate | date : "dd/MM/yyyy" }}
            </strong>
            e seu acesso ao Portal de logons foi bloqueado.
            <strong
              >Complete sua recertificação para restabelecer seu acesso.</strong
              >
          }
        </span>
      </pl-alert>
        <div class="sub-title">
          Você continua exercendo o papel de <strong>{{ userProfile }}</strong>?
        </div>
        <div class="disclaimer">
          <div class="disclaimer__title">Dados do contrato:</div>
          <div class="disclaimer__name">
            {{ companyInfo?.name }}
          </div>
          <div class="disclaimer__document">
            CNPJ: {{ companyInfo?.document | document }}
          </div>
        </div>
        <div class="actions">
          <seds-radio-button
            [(model)]="selectedItem"
            [items]="options"
          ></seds-radio-button>
          @if (selectedItem === options[1]) {
            <section class="confirm__alert">
              <i class="material-icons-round">warning</i>
              <blockquote [attr.cite]="urlToRedirect" class="confirm__alert__blockquote">
                <p>
                  Atenção! Ao confirmar esta ação, você perderá o acesso ao Portal de
                  Logons, permanecendo com acesso ao Menu de Produtos da Serasa
                  Experian. Será necessário realizar um novo login para concluir a
                  ação.
                </p>
                <p>
                  Após confirmar que não é mais o {{ userProfile }} desse contrato,
                  por favor, entre em contato com a nossa central de atendimento para
                  atualizar o novo responsável.
                </p>
                <p>
                  <a [href]="urlToRedirect" target="_blank"
                    >Confira aqui como é o processo de atualização do novo
                    responsável.</a
                    >
                  </p>
                </blockquote>
              </section>
            }
          </div>
        </section>
      } @else {
        @if (this.selectedItem === this.managerOpt['NO']) {
          <div
            class="approved__container"
            >
            <img
              src="assets/icons/privacy/icon_check_success.svg"
              alt="Ícone de sucesso"
              />
            <span class="approved__container__title">Obrigado!</span>
            <span class="approved__container__description"
              >Você será desconectado do Portal de logons.</span
              >
              <seds-loaders-spinner></seds-loaders-spinner>
            </div>
          } @else {
            <div class="approved__container">
              <img
                src="assets/icons/privacy/icon_check_success.svg"
                alt="Ícone de sucesso"
                />
              <span class="approved__container__title">Obrigado!</span>
              <span class="approved__container__description"
                >Recertificação realizada com sucesso!</span
                >
                <seds-loaders-spinner></seds-loaders-spinner>
              </div>
            }
          }
        } @else {
          <ng-container>
            <div class="error">
              <div class="error__content">
                <div class="icon">
                  <svg
                    width="66"
                    height="65"
                    viewBox="0 0 66 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                      d="M65 32.5C65 50.1731 50.6731 64.5 33 64.5C15.3269 64.5 1 50.1731 1 32.5C1 14.8269 15.3269 0.5 33 0.5C50.6731 0.5 65 14.8269 65 32.5Z"
                      stroke="#FEA8B8"
                      />
                    <path
                      d="M33 62.5625C49.6031 62.5625 63.0625 49.1031 63.0625 32.5C63.0625 15.8969 49.6031 2.4375 33 2.4375C16.3969 2.4375 2.9375 15.8969 2.9375 32.5C2.9375 49.1031 16.3969 62.5625 33 62.5625Z"
                      stroke="#FEA8B8"
                      stroke-width="4"
                      />
                    <path
                      d="M43.8703 24.0622L35.4317 32.5L43.8695 40.937C44.18 41.2621 44.3509 41.6958 44.3458 42.1453C44.3406 42.5947 44.1598 43.0243 43.842 43.3422C43.5243 43.6601 43.0947 43.841 42.6452 43.8462C42.1958 43.8515 41.7621 43.6807 41.4369 43.3704L33.0007 34.9317L24.5629 43.3696C24.2377 43.6799 23.804 43.8507 23.3546 43.8454C22.9051 43.8402 22.4755 43.6593 22.1577 43.3414C21.8399 43.0235 21.6591 42.5939 21.654 42.1445C21.6489 41.695 21.8198 41.2613 22.1303 40.9362L30.5681 32.4992L22.1303 24.0614C21.8077 23.7388 21.6265 23.3012 21.6265 22.845C21.6265 22.3888 21.8077 21.9514 22.1303 21.6288C22.4528 21.3063 22.8904 21.125 23.3466 21.125C23.8028 21.125 24.2403 21.3063 24.5629 21.6288L33.0007 30.0667L41.4385 21.6467C41.7608 21.3335 42.1932 21.1593 42.6426 21.1617C43.092 21.1641 43.5224 21.3429 43.8413 21.6596C44.1602 21.9762 44.342 22.4054 44.3476 22.8547C44.3532 23.3041 44.1821 23.7377 43.8711 24.0622H43.8703Z"
                      fill="#E4002B"
                      />
                  </svg>
                </div>
                <div class="description">
                  <p class="red-alert">Não foi possível carregar informações</p>
                  <span
                    >Estamos trabalhando para resolver esse problema.<br />
                    Por favor, tente novamente mais tarde e, se o erro persistir, entre
                    em contato com a nossa equipe de atendimento.</span
                    >
                  </div>
                </div>
              </div>
            </ng-container>
          }

          @if (mode && !success) {
            <footer class="action-footer">
              @if (!this.hasError) {
                <seds-basic-button
                  type="button"
                  title="Salvar"
                  [disabled]="selectedItem === undefined"
                  (click)="recertificate()"
                  >
                </seds-basic-button>
              }
            </footer>
          }

          @if (!success && !mode) {
            <pl-action-footer>
              <div class="action-footer__back" (click)="closeSideNav()">
                <span class="material-icons">arrow_back_ios</span>
                <span>Voltar</span>
              </div>
              @if (!this.hasError) {
                <seds-basic-button
                  type="button"
                  title="Salvar"
                  [disabled]="selectedItem === undefined"
                  (click)="recertificate()"
                ></seds-basic-button>
              }
            </pl-action-footer>
          }



          <ng-template #error>
            <ng-container>
              <div class="error">
                <div class="error__content">
                  <div class="icon">
                    <svg
                      width="66"
                      height="65"
                      viewBox="0 0 66 65"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      >
                      <path
                        d="M65 32.5C65 50.1731 50.6731 64.5 33 64.5C15.3269 64.5 1 50.1731 1 32.5C1 14.8269 15.3269 0.5 33 0.5C50.6731 0.5 65 14.8269 65 32.5Z"
                        stroke="#FEA8B8"
                        />
                      <path
                        d="M33 62.5625C49.6031 62.5625 63.0625 49.1031 63.0625 32.5C63.0625 15.8969 49.6031 2.4375 33 2.4375C16.3969 2.4375 2.9375 15.8969 2.9375 32.5C2.9375 49.1031 16.3969 62.5625 33 62.5625Z"
                        stroke="#FEA8B8"
                        stroke-width="4"
                        />
                      <path
                        d="M43.8703 24.0622L35.4317 32.5L43.8695 40.937C44.18 41.2621 44.3509 41.6958 44.3458 42.1453C44.3406 42.5947 44.1598 43.0243 43.842 43.3422C43.5243 43.6601 43.0947 43.841 42.6452 43.8462C42.1958 43.8515 41.7621 43.6807 41.4369 43.3704L33.0007 34.9317L24.5629 43.3696C24.2377 43.6799 23.804 43.8507 23.3546 43.8454C22.9051 43.8402 22.4755 43.6593 22.1577 43.3414C21.8399 43.0235 21.6591 42.5939 21.654 42.1445C21.6489 41.695 21.8198 41.2613 22.1303 40.9362L30.5681 32.4992L22.1303 24.0614C21.8077 23.7388 21.6265 23.3012 21.6265 22.845C21.6265 22.3888 21.8077 21.9514 22.1303 21.6288C22.4528 21.3063 22.8904 21.125 23.3466 21.125C23.8028 21.125 24.2403 21.3063 24.5629 21.6288L33.0007 30.0667L41.4385 21.6467C41.7608 21.3335 42.1932 21.1593 42.6426 21.1617C43.092 21.1641 43.5224 21.3429 43.8413 21.6596C44.1602 21.9762 44.342 22.4054 44.3476 22.8547C44.3532 23.3041 44.1821 23.7377 43.8711 24.0622H43.8703Z"
                        fill="#E4002B"
                        />
                    </svg>
                  </div>
                  <div class="description">
                    <p class="red-alert">Não foi possível carregar informações</p>
                    <span
                      >Estamos trabalhando para resolver esse problema.<br />
                      Por favor, tente novamente mais tarde e, se o erro persistir, entre
                      em contato com a nossa equipe de atendimento.</span
                      >
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-template>
